import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import QualifiedPostFormSection from '../components/QualifiedPostFormSection';
import { trackCompleteRegistration, trackScheduleCall } from '../utils/metaPixel';
import {
  ackQualificationMetaPixel,
  sendCapiCompleteRegistration,
  sendCapiWhitelistedEvent,
  getContactFromVideoAccess,
} from '../utils/funnelTracking';
import { newEventId } from '../utils/metaCookies';

// Agendas de Google Calendar (appointment schedules) por coach.
// El lead agenda con el coach que eligió en el formulario; sin dato, con Agustín.
const AGENDA_IDS = {
  agustin: 'AcZssZ0AIq_QDA1QajLMFyBztn3oqp0wyAVrg5aikvGjxCldsKAeEfMIBhzJk6kbBc1XIx5lMcfmUBsX',
  'Carlos Dufeu': 'AcZssZ1OqCtGaRORI76sa-15_vs1NF-tLv7cyZPd7-uzl-qK9ccc4oqjYf8Zgs7Jejv-8yTwbKV4GDRx',
  'Alvaro Niklitschek': 'AcZssZ1KU_iLlGHlbX-D5uNhNfnX_7yzPJuuNmKtnx_PSr53D9Aj-I7zxb4hA6-VRJpLngnvag0e-oeV',
};
const buildAgendaUrl = (id) => `https://calendar.google.com/calendar/appointments/schedules/${id}?gv=true`;

const QualifiedPostFormPage = () => {
  const navigate = useNavigate();

  const coachAgenda = localStorage.getItem('au_agenda_coach') || 'agustin';
  const agendaUrl = buildAgendaUrl(AGENDA_IDS[coachAgenda] || AGENDA_IDS.agustin);

  // "Ya agendé mi llamada": es el paso medible más cercano a la venta. Antes solo
  // navegaba a /nutrition-1 sin reportar nada, así que no había forma de saber
  // cuántos calificados llegaban a agendar.
  const handleAgendado = () => {
    const backendUrl = (process.env.REACT_APP_API_URL || 'http://localhost:3001').replace(/\/$/, '');
    const { email, nombre, whatsapp } = getContactFromVideoAccess();

    let eventId = sessionStorage.getItem('meta_schedule_event_id');
    if (!eventId) {
      eventId = newEventId('sch');
      sessionStorage.setItem('meta_schedule_event_id', eventId);
    }

    trackScheduleCall(eventId);
    sendCapiWhitelistedEvent(backendUrl, {
      eventName: 'Schedule',
      eventId,
      email,
      nombre,
      whatsapp,
    });

    navigate('/nutrition-1');
  };

  useEffect(() => {
    const backendUrl = (process.env.REACT_APP_API_URL || 'http://localhost:3001').replace(/\/$/, '');
    // FormPage sincroniza este storage con lo que el lead escribió en el formulario,
    // así que acá el contacto ya es el correcto.
    const { email, nombre, whatsapp } = getContactFromVideoAccess();

    // Reutilizar el eventId si ya existe en esta sesión de navegador.
    // Evita duplicados cuando React StrictMode re-ejecuta el efecto en desarrollo,
    // o si el usuario navega hacia atrás y vuelve a /qualified.
    // Pixel y CAPI siempre usan el mismo ID → Meta desduplicará correctamente.
    let eventId = sessionStorage.getItem('meta_cr_event_id');
    if (!eventId) {
      eventId = `cr_${Date.now()}_${Math.random().toString(36).slice(2)}`;
      sessionStorage.setItem('meta_cr_event_id', eventId);
    }

    trackCompleteRegistration(eventId);
    ackQualificationMetaPixel(backendUrl, email, true);
    sendCapiCompleteRegistration(backendUrl, email, eventId, { nombre, whatsapp });
  }, []);

  return (
    <QualifiedPostFormSection
      agendaUrl={agendaUrl}
      onAgendado={handleAgendado}
    />
  );
};

export default QualifiedPostFormPage;
